/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".manage-accounts-content[_ngcontent-%COMP%] {\n  padding: 10px !important;\n}\n\n.edit-link[_ngcontent-%COMP%] {\n  text-align: right;\n  cursor: pointer;\n  color: #3F8F8B;\n  text-decoration: none;\n}\n\n.add-acct-btn[_ngcontent-%COMP%]{\n  font-weight: 600 !important;\n  color: #3F8F8B !important;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/manage-accounts-container/manage-accounts-container.component.css.shim.ngstyle.js.pre-build-optimizer.js